module.exports = __webpack_public_path__ + "img/logo.19dc9726.png";